/**
 * Observability Event Types
 *
 * Defines typed structures for AI observability events including:
 * - AiSuggestEvent: Logged for every /ai/suggest call
 * - AiFeedbackEvent: Logged for every /ai/feedback call
 * - AiApplyEvent: Logged for every /ai/apply call
 *
 * @module types/observability-events
 * @see SPEC-015 Requirements 7.1-7.6, 8.1-8.5, 9.1-9.5
 */
/**
 * Maximum number of candidates in suggest event logs.
 * @see Requirement 7.5 - candidates array max 10
 */
export const MAX_SUGGEST_CANDIDATES = 10;
//# sourceMappingURL=observability-events.js.map